export default "__VITE_ASSET__Dk_AzSdk__"